import type { FaireProductEntity } from "../../entity_types/product";

export const p_3d5gx35zj3: FaireProductEntity = {
  token: "p_3d5gx35zj3",
  type: "product",
  name: "Scalloped Enamel Tray - Festival of Flowers",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/0b80a0798ef933a4ea9a0318097feb6d01e26e23c58f717391f046ea2280425d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/843bc47d57f1ba8bcfbae0e2864e16659fc9db8b508939ac10360e77dfdcbbcd.jpeg",
  ],
  priceDollars: 17,
  description:
    'Bring a sense of timeless beauty to your table with this scallop-edged enamel serving tray, featuring exquisite floral illustrations originally hand-painted in the early 1600s. The artwork was discovered on the blank pages of a Bavarian christening book published in 1596, where an unknown artist added delicate watercolour blooms with extraordinary detail and care.\n\nRoomytown’s design team in Bath, UK, has carefully adapted and enhanced the original artwork, breathing new life into these centuries-old florals while preserving their charm. The result is a food-safe tray that’s as practical as it is decorative—ideal for serving afternoon treats, styling a shelf, or simply displaying as a piece of functional art.\n\nEach tray is handcrafted by skilled artisans in India, and features subtle variations that reflect the beauty of handmade design. A celebration of creativity past and present.\n\n H 178 mm x W 310 mm x D 10 mm / H 7" X W 12.2" X D 0.4"',
  tags: [],
  msrpDollars: 37.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:38.621Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
